export const requestMessagesSchema = {
  contactAdmin: "Comunicate con el administrador",
  dontConvertURLtoase64: "Ocurrió un problema con la URL de la imagen",
  problemExistTryLater: "Ocurrió un problema, intenta más tarde",
  successfullyOperation: "Operación exitosa",
  tryLater: "Intentá más tarde",
};
